/* eslint-disable no-console */
import { createReducer, SUCCESS, updateObject } from 'Stores'
import { GET_CONTACT } from './constants'

export const initialState = {
  type: null,
  getContact: []
}

function getContactSuccess(state, { payload }) {
  const { contact } = payload
  return updateObject(state, {
    getContact: contact
  })
}

export default createReducer(initialState, {
  [SUCCESS(GET_CONTACT)]: getContactSuccess
})
